export default __webpack_public_path__ + "static/cert-5-img-ecfd14c80b9aba32a773c783ecd60f52.png";